import { useCallback, useEffect } from "react";
import { useNavigate } from "react-router";

import { useToast } from "@chakra-ui/react";
import { useAuth, useRestoreUrl } from "@equidefi/portals/hooks/useAuth";

const DEFAULT_MESSAGE = "You must be logged in to access this page.";

export const useRequireUser = ({ destination = "/", onMount = true } = {}) => {
  const { isLoggedIn, handleLogout } = useAuth();
  const toast = useToast();
  const { clear, url } = useRestoreUrl();

  const navigate = useNavigate();

  const clearSession = useCallback(() => {
    handleLogout();
    clear();
  }, [url, clear, handleLogout]);

  const triggerLogout = useCallback(
    ({ type = "error", message = DEFAULT_MESSAGE } = {}) => {
      clearSession();

      toast({
        status: type,
        description: message,
      });

      navigate(destination);
    },
    [navigate, destination, clearSession],
  );

  useEffect(() => {
    if (onMount && !isLoggedIn) {
      triggerLogout();
    }
  }, []);

  return triggerLogout;
};
